/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ScDataBuilds,
  ScDataCompare,
  ScDataCompareParams,
  ScDataPatchSummary,
  ScDataSources,
  ScDataVersion,
  SchemaValidationErrorResponse,
  StandardError,
  Version
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary SC Data Builds
 */
export const scDataBuilds = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataBuilds>(
      {url: `/sc-data/builds`, method: 'GET', signal
    },
      );
    }




export const getScDataBuildsQueryKey = () => {
    return [
    'sc-data','builds'
    ] as const;
    }


export const getScDataBuildsQueryOptions = <TData = Awaited<ReturnType<typeof scDataBuilds>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataBuilds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataBuildsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataBuilds>>> = ({ signal }) => scDataBuilds(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataBuilds>>, TError, TData>
}

export type ScDataBuildsQueryResult = NonNullable<Awaited<ReturnType<typeof scDataBuilds>>>
export type ScDataBuildsQueryError = ErrorType<unknown>


/**
 * @summary SC Data Builds
 */

export function useScDataBuilds<TData = Awaited<ReturnType<typeof scDataBuilds>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataBuilds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataBuildsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Compare two SC Data builds
 */
export const scDataCompare = (
    params: MaybeRefOrGetter<ScDataCompareParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ScDataCompare>(
      {url: `/sc-data/compare`, method: 'GET',
        params, signal
    },
      );
    }




export const getScDataCompareQueryKey = (params?: MaybeRefOrGetter<ScDataCompareParams>,) => {
    return [
    'sc-data','compare', ...(params ? [params] : [])
    ] as const;
    }


export const getScDataCompareQueryOptions = <TData = Awaited<ReturnType<typeof scDataCompare>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params: MaybeRefOrGetter<ScDataCompareParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataCompare>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataCompareQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataCompare>>> = ({ signal }) => scDataCompare(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataCompare>>, TError, TData>
}

export type ScDataCompareQueryResult = NonNullable<Awaited<ReturnType<typeof scDataCompare>>>
export type ScDataCompareQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Compare two SC Data builds
 */

export function useScDataCompare<TData = Awaited<ReturnType<typeof scDataCompare>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params: MaybeRefOrGetter<ScDataCompareParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataCompare>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataCompareQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary SC Data patch summary
 */
export const scDataPatchSummary = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataPatchSummary>(
      {url: `/sc-data/patch-summary`, method: 'GET', signal
    },
      );
    }




export const getScDataPatchSummaryQueryKey = () => {
    return [
    'sc-data','patch-summary'
    ] as const;
    }


export const getScDataPatchSummaryQueryOptions = <TData = Awaited<ReturnType<typeof scDataPatchSummary>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataPatchSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataPatchSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataPatchSummary>>> = ({ signal }) => scDataPatchSummary(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataPatchSummary>>, TError, TData>
}

export type ScDataPatchSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof scDataPatchSummary>>>
export type ScDataPatchSummaryQueryError = ErrorType<StandardError>


/**
 * @summary SC Data patch summary
 */

export function useScDataPatchSummary<TData = Awaited<ReturnType<typeof scDataPatchSummary>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataPatchSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataPatchSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary SC Data Sources
 */
export const scDataSources = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataSources>(
      {url: `/sc-data/sources`, method: 'GET', signal
    },
      );
    }




export const getScDataSourcesQueryKey = () => {
    return [
    'sc-data','sources'
    ] as const;
    }


export const getScDataSourcesQueryOptions = <TData = Awaited<ReturnType<typeof scDataSources>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataSources>>> = ({ signal }) => scDataSources(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>
}

export type ScDataSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof scDataSources>>>
export type ScDataSourcesQueryError = ErrorType<unknown>


/**
 * @summary SC Data Sources
 */

export function useScDataSources<TData = Awaited<ReturnType<typeof scDataSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataSourcesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary SC Data Version
 */
export const scDataVersion = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataVersion>(
      {url: `/sc-data/version`, method: 'GET', signal
    },
      );
    }




export const getScDataVersionQueryKey = () => {
    return [
    'sc-data','version'
    ] as const;
    }


export const getScDataVersionQueryOptions = <TData = Awaited<ReturnType<typeof scDataVersion>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataVersion>>> = ({ signal }) => scDataVersion(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>
}

export type ScDataVersionQueryResult = NonNullable<Awaited<ReturnType<typeof scDataVersion>>>
export type ScDataVersionQueryError = ErrorType<unknown>


/**
 * @summary SC Data Version
 */

export function useScDataVersion<TData = Awaited<ReturnType<typeof scDataVersion>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Version of Fleetyards
 */
export const version = (

 signal?: AbortSignal
) => {


      return axiosClient<Version>(
      {url: `/version`, method: 'GET', signal
    },
      );
    }




export const getVersionQueryKey = () => {
    return [
    'version'
    ] as const;
    }


export const getVersionQueryOptions = <TData = Awaited<ReturnType<typeof version>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof version>>> = ({ signal }) => version(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>
}

export type VersionQueryResult = NonNullable<Awaited<ReturnType<typeof version>>>
export type VersionQueryError = ErrorType<unknown>


/**
 * @summary Version of Fleetyards
 */

export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






